import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getPageHeadersConfigs() {
    return {
        custom: {
            [PALETTE_IDS.INTERFACE]: {
                ApplicationMenu: {
                    logo: {
                        style: {
                            height: 32,
                            _mobile_height: 24,
                            width: 156,
                            _mobile_width: 117,
                        },
                    },
                    logoButton: {
                        style: {
                            base: {
                                flexBasis: 156,
                                _mobile_flexBasis: 117,
                            },
                        },
                    },
                },
                // This is needed to match Casino header design - DBX-9716
                MainNavigationBar: {
                    linkButtons: {
                        selectableButton: {
                            unselected: {
                                style: {
                                    base: {
                                        padding: '0 28px',
                                    },
                                },
                            },
                            selected: {
                                style: {
                                    base: {
                                        padding: '0 28px',
                                        fontFamily: FONT.FAMILY_SECOND,
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.APPLICATION_HEADER]: {
                APPLICATION_HEADER_CROSS_APP_SELECTOR: {
                    PIVOT_TEXT: {
                        fontFamily: FONT.FAMILY_SECOND,
                        color: COLOR.BRAND.FOREGROUND4,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        textTransform: 'uppercase',
                    },
                    PIVOT_SELECTED_TEXT: {
                        fontFamily: FONT.FAMILY_SECOND,
                        color: COLOR.BRAND.FOREGROUND4,
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        textTransform: 'uppercase',
                    },
                    // use indicator as a selected background to match Zeplin design
                    PIVOT_INDICATOR_BG: COLOR.BRAND.BACKGROUND7,
                    PIVOT_INDICATOR_HEIGHT: 40,
                    PIVOT_INDICATOR_BOTTOM: 0,
                },
                APPLICATION_HEADER_USER_INFO_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    textTransform: 'uppercase',
                },

                // leave like it is now, not like in Zeplin
                APPLICATION_HEADER_NAV_BAR_BG: COLOR.BRAND.BACKGROUND7,
                APPLICATION_HEADER_NAV_BAR_PAGE_SELECTOR: {
                    PIVOT_TEXT: {
                        fontFamily: FONT.FAMILY_SECOND,
                        color: COLOR.BRAND.FOREGROUND4,
                        flexBasis: 'auto',
                    },
                    PIVOT_SELECTED_TEXT: {
                        fontFamily: FONT.FAMILY_SECOND,
                        color: COLOR.BRAND.FOREGROUND4,
                        flexBasis: 'auto',
                    },
                    PIVOT_INDICATOR_HEIGHT: 0,
                },
                APPLICATION_HEADER_NAV_BAR_SESSION_TIME_LABEL_TEXT: {
                    fontSize: '9px',
                    color: COLOR.BRAND.FOREGROUND4,
                },
                APPLICATION_HEADER_NAV_BAR_SESSION_TIME_VALUE_TEXT: {
                    fontSize: '11px',
                    color: COLOR.BRAND.FOREGROUND4,
                },
                SEARCH_POPOVER: {
                    POPOVER_BG: COLOR.BRAND.BACKGROUND1,
                    POPOVER_TEXT: COLOR.BRAND.FOREGROUND3,
                },
            },
            [PALETTE_IDS.INTERFACE]: {
                BANNER_BG: COLOR.BASE.PAGE,
                BREADCRUMBS_TEXT: COLOR.BRAND.FOREGROUND2,
                MOBILE_BREADCRUMBS_BG: COLOR.BRAND.BACKGROUND6,
                MOBILE_BREADCRUMBS_TEXT: COLOR.BRAND.FOREGROUND5,
                MOBILE_BREADCRUMBS_QUICK_NAVIGATION_CATEGORY_TEXT: COLOR.BRAND.FOREGROUND4,
                MOBILE_BREADCRUMBS_QUICK_NAVIGATION_TOURNAMENT_TEXT: COLOR.BRAND.FOREGROUND5,
                MOBILE_BREADCRUMBS_QUICK_NAVIGATION_ICON_COLOR: COLOR.BRAND.FOREGROUND5,
                SYSTEM_INITIALIZATION_TEXT: {
                    color: COLOR.RESERVED.WHITE,
                    textTransform: 'uppercase',
                },
            },
            [PALETTE_IDS.SETTINGS]: {
                SETTINGS_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND3,
                    textTransform: 'uppercase',
                    fontSize: FONT.SIZE_MEDIUM,
                },
            },
        },
    };
}
